export default "__VITE_ASSET__EVkkT1Q5__"